import { getCookie } from '../utils/cookie';

import request, { apiURL } from '../utils/api';
class CommonAreaLocationService {
  getAll(organizationId: string, propertyId: string) {
    const options = {
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };
    return request(
      `${apiURL}/${organizationId}/${propertyId}/commonAreaLocation`,
      options,
    );
  }
}

export default CommonAreaLocationService;
